var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking-wide text-xs text-center py-2 bg-primary-dark text-white opacity-25"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('small',{staticClass:"text-xs ml-2"},[_vm._v(_vm._s(_vm.version))])])
}
var staticRenderFns = []

export { render, staticRenderFns }